<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 23.3c-.2 0-.5-.1-.7-.2-.2-.1-.5-.3-.8-.5-.8-.5-2.1-1.4-3.5-2.5-2.4-1.9-5.5-5-6.6-8.5C-1 7 1.1 2.4 5.1 1.1 7.5.3 10 .8 12 2.2 13.9.8 16.5.3 18.8 1c4.1 1.4 6.2 6 4.7 10.6-1.1 3.5-4.2 6.5-6.6 8.5-1.1.9-2.2 1.7-3.5 2.5-.3.2-.6.4-.9.5 0 .1-.3.2-.5.2zm.8-1.8zM7.5 3.3c-.5 0-1 .1-1.5.2-2.8.9-4.1 4-3 7.3.9 2.9 3.7 5.6 5.8 7.3 1.3 1 2.4 1.8 3.2 2.3l.1.1.1-.1c1.1-.7 2.2-1.5 3.2-2.3 2.1-1.7 4.8-4.4 5.7-7.3 1.1-3.3-.3-6.4-3-7.3-1.5-.5-3.3-.2-4.5.7-.9.7-2.2.7-3.1 0-.9-.6-2-.9-3-.9z"
    />
  </svg>
</template>
